import brandConfig from '../config/brand';

export const theme = {
  colors: {
    white: '#fff',
    black: '#000',
    // Brand-specific primary colors from brand config
    primary: brandConfig.colors.primary,
    primary100: brandConfig.colors.primary100,
    primary200: brandConfig.colors.primary200,
    primary300: brandConfig.colors.primary300,
    primary400: brandConfig.colors.primary400,
    // Common colors across all brands
    red: '#FA4032',
    gray: '#f1f1f1',
    gray500: '#B3B3B3',
    gray900: '#333',
    green: '#73EC8B',
    green900: '#0F9D58',
    yellow: '#FFD700',
    yellow900: '#FFA800',
    orange: '#FFA500'
  },
  fontSize: {
    extraSmall: '0.8rem',
    small: '0.9rem',
    medium: '1rem',
    large: '1.5rem'
  }
};

export type ColorKeys = keyof (typeof theme)['colors'];
